import React from 'react';
import PropTypes from 'prop-types';
import Component from '@ux/component';
import XIcon from '@ux/icon/x';

/**
 * Alert close button.
 *
 * This is the button that is used to dismiss the alert message.
 *
 * @class Close
 * @public
 */
export default class Close extends Component {
  /**
   * Render the close button for the alert, but only if an `onClick` prop was
   * specified.
   *
   * @returns {ReactElement} Button
   * @public
   */
  render() {
    if (!this.props.onClick) {
      return null;
    }

    return (
      <button
        type='button'
        className='alert-closebutton'
        aria-label='Close'
        onClick={ this.props.onClick }>
        <XIcon/>
      </button>
    );
  }
}

/**
 * Property types.
 *
 * @type {Object}
 * @private
 */
Close.propTypes = {
  /** Handler for when close button is clicked */
  onClick: PropTypes.func
};
